import React, { Component } from "react";
import {
  VictoryTooltip,
  VictoryChart,
  VictoryTheme,
  VictoryVoronoiContainer,
  VictoryLine,
  VictoryAxis,
} from "victory";
import isEmpty from "lodash/isEmpty";
import { withSize } from "react-sizeme";
import { hummanizeNumber } from "../../../lib/numbers";
import moment from "moment";
import get from "lodash/get";

class StatsLineGraph extends Component {
  render() {
    var victoryData = [];
    var yData = [];
    var xData = [];
    for (var point of this.props.data) {
      var newPoint = {
        x: new Date(point.date * 1000),
        y: point.count,
      };
      newPoint.label =
        moment(newPoint.x).format(this.getXAxisTickFormat()) + " - " + hummanizeNumber(newPoint.y);
      victoryData.push(newPoint);
      xData.push(point.date);
      yData.push(point.count);
    }

    var highestValue = Math.max(...yData);
    var yMin = 0;
    var yMax = highestValue !== 0 ? highestValue : 100;
    var xMin = new Date(Math.min(...xData) * 1000);
    var xMax = new Date(Math.max(...xData) * 1000);
    if (isEmpty(victoryData)) {
      return null;
    }

    return (
      <VictoryChart
        containerComponent={<VictoryVoronoiContainer />}
        theme={VictoryTheme.material}
        scale={{ x: "time" }}
        width={this.props.size.width}
        height={350}
        domain={{
          x: [xMin, xMax],
          y: [yMin, yMax],
        }}
        domainpadding={30}>
        <VictoryAxis dependentAxis tickFormat={y => hummanizeNumber(y)} />
        <VictoryAxis
          fixLabelOverlap={true}
          tickFormat={x => moment(x).format(this.getXAxisTickFormat())}
        />
        <VictoryLine data={victoryData} labelComponent={<VictoryTooltip />} />
      </VictoryChart>
    );
  }

  getXAxisTickFormat = () => {
    var timeRange = get(this.props, "statsForm.timeRange", "allTime");
    switch (timeRange) {
      case "allTime":
        return "MMM YYYY";
      case "year":
        return "MMM";
      case "month":
      case "week":
        return "MM/DD";
      default:
        return "MM/DD h:mm a";
    }
  };
}

export default withSize()(StatsLineGraph);
